import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { HEIGHT_OFFSET } from "app/utils/constants/constants";

const LoadingView = ({ message, size }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: `calc(100vh - ${HEIGHT_OFFSET.DEFAULT})`,
    }}
  >
    <CircularProgress size={size} />
    <Typography variant="h6" gutterBottom sx={{ mt: 2 }} color="text.secondary">
      {message}
    </Typography>
  </Box>
);

export default LoadingView;
